import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "src/shared/api/base-query";
import { pagedQueryFn } from "src/shared/api/paged-query-fn";

import { ISeason } from "../shared/interfaces/season";

export const seasonsApi = createApi({
  reducerPath: "seasonsApi",
  baseQuery,
  endpoints: (builder) => ({
    fetchSeasons: builder.query<ISeason[], void>({
      queryFn: pagedQueryFn<ISeason, ISeason[]>({ url: "SeasonsV2" }, (dtos) =>
        [...dtos].sort((a, b) => (a.name > b.name ? -1 : 1))
      ),
    }),
  }),
});

export const { useFetchSeasonsQuery } = seasonsApi;
